import { questionsMapper } from "../../components/activityQuestions/utils/mapQuestions";
import { initialState } from "../initialState";
import * as ActivityQuestionsActions from "./activityQuestionsActions";
import { EXTRA_FOLLOWUP_QUESTIONS } from "./additionalQuestionEncap";

export const activityQuestionsReducer = (state = initialState.activityQuestions, action) => {
    switch (action.type) {
        case ActivityQuestionsActions.REQUEST_ACTIVITY_QUESTIONS:
            return {
                ...state,
                questions: { ...state.questions, [action.payload.followUpUUID]: { mappedQuestions: [] } },
                isFetching: true,
                isError: false,
                error: null,
            };
        case ActivityQuestionsActions.REQUEST_ACTIVITY_QUESTIONS_SUCCESS: {
            // Check if any question matches the condition
            const shouldAddExtraQuestions = action.payload.questions.some(
                (question) => question.fieldName && question.fieldName.toLowerCase().includes("is work site accessible by vehicles"),
            );

            // Add EXTRA_FOLLOWUP_QUESTIONS if the condition is met
            const updatedQuestions = shouldAddExtraQuestions ? [...action.payload.questions, ...EXTRA_FOLLOWUP_QUESTIONS] : action.payload.questions;

            return {
                ...state,
                questions: {
                    ...state.questions,
                    [action.payload.followUpUUID]: {
                        mappedQuestions: questionsMapper(updatedQuestions),
                    },
                },
                isFetching: false,
                isError: false,
                error: null,
            };
        }
        case ActivityQuestionsActions.REQUEST_EXISTING_ACTIVITY_QUESTIONS_SUCCESS:
            return {
                ...state,
                questions: {
                    ...state.questions,
                    [action.payload.followUpUUID]: {
                        apiResponse: action.payload.apiResponse,
                        mappedQuestions: questionsMapper(action.payload.questions, action.payload.answers),
                    },
                },
                isFetching: false,
                isError: false,
                error: null,
            };
        case ActivityQuestionsActions.REQUEST_ACTIVITY_QUESTIONS_ERROR:
            return {
                ...state,
                questions: { ...state.questions, [action.payload.followUpUUID]: { mappedQuestions: [] } },
                isFetching: false,
                isError: true,
                error: action.payload.error,
            };
        case ActivityQuestionsActions.ANSWER_ACTIVITY_QUESTION:
            return {
                ...state,
                questions: {
                    ...state.questions,
                    [action.payload.followUpUUID]: {
                        mappedQuestions: state.questions[action.payload.followUpUUID]?.mappedQuestions?.map((question) =>
                            question.id === action.payload.questionId
                                ? {
                                      ...question,
                                      value: action.payload.value,
                                      isAnswered: action.payload.isAnswered,
                                      formattedValue: action.payload.formattedValue,
                                  }
                                : question,
                        ),
                    },
                },
            };
        default:
            return state;
    }
};
